module.exports = __webpack_public_path__ + "static/media/ea.b9e32202.gif";